import clsx from 'clsx';
import { PropsWithChildren } from 'preact/compat';

import styles from '../Stack.module.scss';

interface ItemProps {
  fill?: boolean;
  stretch?: boolean;
  classNames?: string[];
}

export function Item({
  fill,
  stretch,
  children,
  classNames = [],
}: PropsWithChildren<ItemProps>) {
  const className = clsx(
    styles.Item,
    fill && styles['Item-fill'],
    stretch && styles['Item-stretch'],
    ...classNames,
  );

  return <div className={className}>{children}</div>;
}
